import { ValidationRegex } from '../data/Regex';

export default function getGoogleDocsPreviewUrl(url: string) {
  return `https://docs.google.com/gview?url=${
    ValidationRegex.absolutePath.test(url) ? document.location.origin : ''
  }${url}&embedded=true`;
}
